const selects = () => {
  const selectors = [
    {
      id: "#education-level",
      placeholder: "Образование",
    },
    {
      id: "#education-level-short",
      placeholder: "Образование",
    },
    {
      id: "#Regions",
      placeholder: "Ваш регион",
    },
    {
      id: "#Regions-program",
      placeholder: "Ваш регион",
    },
    {
      id: "#ProgramHome",
      placeholder: "Выберите программу",
    },
    {
      id: "#gender",
      placeholder: "Пол",
    },
    {
      id: "#citizenship",
      placeholder: "Гражданство",
    },
    {
      id: "#date",
      placeholder: "Выберите дату потока",
    },
    {
      id: "#date-program",
      placeholder: "Выберите дату потока",
    },
    {
      id: "#tariff",
      placeholder: "Выберите тариф",
    },
    {
      id: "#tariff-program",
      placeholder: "Выберите тариф",
    },
  ];

  selectors.forEach((item) => {
    let selector = $(item.id),
      message = "",
      placeholder;

    /* вывод сообщения в зависимости от поля */
    if (item.id == "#ProgramHome") {
      message = "Нет доступных программ";
    } else {
      message = "Ничего не найдено";
    }
    /* */

    placeholder = item.placeholder;

    selector.select2({
      placeholder: placeholder,
      language: {
        noResults: function () {
          return message;
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    selector.trigger("change");
  });
};

export default selects;
